"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseTabListPropDefs = void 0;
const index_js_1 = require("../helpers/index.js");
const sizes = ['1', '2'];
const wrapValues = ['nowrap', 'wrap', 'wrap-reverse'];
const justifyValues = ['start', 'center', 'end'];
const baseTabListPropDefs = {
    size: { type: 'enum', className: 'rt-r-size', values: sizes, default: '2', responsive: true },
    wrap: {
        type: 'enum',
        className: 'rt-r-fw',
        values: wrapValues,
        default: undefined,
        responsive: true,
    },
    justify: {
        type: 'enum',
        className: 'rt-r-jc',
        values: justifyValues,
        default: 'start',
        responsive: true,
    },
    color: index_js_1.colorProp,
    highContrast: index_js_1.highContrastProp,
};
exports.baseTabListPropDefs = baseTabListPropDefs;
//# sourceMappingURL=base-tab-list.props.js.map